import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ShareProjectRoleInput } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface ShareProjectRoleMutationInput {
  projectId: number;
  input: ShareProjectRoleInput;
}

/**
 * Mutation hook for granting role-scoped access to a project (Owner/Admin only).
 * Calls POST /projects/:id/share/role.
 * Invalidates the project detail so share arrays refresh.
 */
export function useShareProjectRole() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ projectId, input }: ShareProjectRoleMutationInput) => {
      await apiClient.post(`/projects/${projectId}/share/role`, input);
    },
    onSuccess: (_data, { projectId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projects.byId(projectId) });
    },
  });
}
